import React, { useEffect, useState } from "react"
import SidePanelLayout from "aldoo-ra/SidePanel"
import SpamOverview from "./SpamOverview"
import SpamRuleBrowser from "./SpamRuleBrowser"
import SpamBlacklistBrowser from "./SpamBlacklistBrowser"
import SpamWhitelistBrowser from "./SpamWhitelistBrowser"
import Value from "aldoo-ra/Value"
import Typography from "aldoo-ra/Typography"
import useSpamStatistics from "./useSpamStatistics"

const SpamProtectionHome = () => {
  // Use the statistics hook to automatically fetch and refresh spam statistics
  const { statistics } = useSpamStatistics()

  // Value hook to monitor changes in spam statistics
  const [statsValue, setStatsValue] = Value("spam-statistics", null)

  // State to track spam statistics for UI updates
  const [blockedCount, setBlockedCount] = useState(0)

  // Update blocked count when statistics change
  useEffect(() => {
    if (statsValue && typeof statsValue.recentlyBlocked === "number") {
      setBlockedCount(statsValue.recentlyBlocked)
    } else {
      setBlockedCount(0)
    }
  }, [statsValue])

  // Sync statistics to the Value hook for access across components
  useEffect(() => {
    if (statistics) {
      setStatsValue(statistics)
    }
  }, [statistics, setStatsValue])

  return (
    <SidePanelLayout
      menuName="AdminSpamProtectionMenu"
      tabs={{
        overview: SpamOverview,
        rules: SpamRuleBrowser,
        blacklist: SpamBlacklistBrowser,
        whitelist: SpamWhitelistBrowser,
      }}
      onMenuItemRender={(item) => {
        // Only show the badge for the blacklist menu item when there are recently blocked items
        if (item.name !== "SpamProtectionBlacklist") return null

        // Only show badge if blocked count is greater than 0
        if (blockedCount <= 0) return null

        // Show notification badge with recently blocked count
        return (
          <div className="min-w-[20px] h-5 flex items-center justify-center rounded-full bg-admin_error px-1.5">
            <Typography variant="admin_txt2" className="text-admin_text_inv">
              {blockedCount > 99 ? "99+" : blockedCount}
            </Typography>
          </div>
        )
      }}
    />
  )
}

export default SpamProtectionHome
